import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { S_TextNumberValue } from 'elements/minute/sidebar/sidebarComponents/atomic/TextNumberValue/TextNumberValue';
import { EFonts } from 'libs/styles/styling';
import { CSSProperties, useEffect, useRef, useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    value?: string;
    autoFocus?: boolean;
    onChange?: (value: string) => void;
    onBlur?: (value: string) => void;
    onFocus?: () => void;
    placeholder: string;
    className?: string;
    style?: CSSProperties;
}

export const MapV2SearchInput = (props: Props): JSX.Element => {
    const [value, setValue] = useState<string>(props.value ?? '');
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (props.value !== value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <S_MapV2SearchInput className={props.className}>
            <S_Icon_Glass icon={['far', 'magnifying-glass']} />
            <S_Input
                ref={ref}
                style={props.style}
                type="text"
                value={value ?? ''}
                placeholder={props.placeholder}
                autoComplete="nope"
                autoFocus={false}
                onChange={(e) => {
                    setValue(e.target.value);
                    props.onChange?.(e.target.value);
                }}
                onBlur={() => {
                    props.onBlur?.(value);
                }}
                onFocus={() => {
                    props.onFocus?.();
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        ref.current?.blur();
                    }
                    e.stopPropagation();
                }}
            />
            {value && (
                <S_Icon_Clear
                    icon={['far', 'xmark']}
                    onClick={() => {
                        setValue('');
                        props.onChange?.('');
                    }}
                />
            )}
        </S_MapV2SearchInput>
    );
};

const S_MapV2SearchInput = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    display: flex;
`;

const S_Icon_Glass = styled(FontAwesomeIcon)`
    color: #041321;
    position: absolute;
    left: 20px;
    font-size: 16px;
`;

const S_Icon_Clear = styled(FontAwesomeIcon)`
    color: #041321;
    position: absolute;
    right: 10px;
    font-size: 16px;
    padding: 8px;
    text-align: center;
    cursor: pointer;
`;

const S_Input = styled(S_TextNumberValue)`
    outline: none;
    border-top: none;
    border-left: none;
    border-right: none;
    box-sizing: border-box;
    padding: 0px 10px 0 50px;
    background: #fafcfe;
    color: #041321;
    font-family: ${EFonts.InterMedium};
    width: ${(props) => (props.width ? props.width : '100%')};
    font-size: 15px;
    border: 1px solid #eaf0f5;
    height: 44px;
    text-align: center;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
    line-height: 24px;
    border-radius: 100px;
    &:focus {
        background: #fff;
    }
    &::placeholder {
        color: #84848c;
        font-size: 15px;
        padding: 0px;
        text-align: left;
        font-family: ${EFonts.InterRegular};
        line-height: 44px;
    }
    text-align: left;
    width: 100%;
`;
